import { useEffect } from "react";

const setContent = (selector, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute("content", value);
};

export function usePageMeta({ title, description }) {
  useEffect(() => {
    document.title = title;
    setContent('meta[name="description"]', description);
    setContent('meta[property="og:title"]', title);
    setContent('meta[property="og:description"]', description);
    setContent('meta[name="twitter:title"]', title);
    setContent('meta[name="twitter:description"]', description);
  }, [title, description]);
}
